import { useContext } from 'react';
import { NotificationContext } from '../contexts';
import type { Notification, NotificationCategory } from '../api';

interface UseNotificationsReturn {
  notifications: Notification[];
  unreadCount: number;
  isLoading: boolean;
  error: string | null;
  hasMore: boolean;
  // Actions
  refresh: () => Promise<void>;
  loadMore: () => Promise<void>;
  markAsRead: (notificationId: string) => Promise<void>;
  markAllAsRead: () => Promise<void>;
  setCategory: (category: NotificationCategory) => void;
  category: NotificationCategory;
  // Subscribe to global merge request changes (for board pages that show pending merge requests)
  subscribeToGlobalMergeChanges: (callback: () => void) => () => void;
}

export function useNotifications(): UseNotificationsReturn {
  const context = useContext(NotificationContext);

  if (!context) {
    throw new Error('useNotifications must be used within a NotificationProvider');
  }

  return context;
}
